import { Spinner, Stack, Text, type StackProps } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";

type LoadingSpinnerProps = Partial<StackProps>;

export const LoadingSpinner = (props: LoadingSpinnerProps) => {
  const i18n = useI18n();

  return (
    <Stack direction="column" alignItems="center" justifyContent="center" mixin={{ minHeight: "100vh" }} {...props}>
      <Spinner size="larger" />
      <Text variant="body_1">{i18n.trans(t("flights_airline_portal_airline_view_loading"))}</Text>
    </Stack>
  );
};
